// import DatetimeUtils from "core/gd/utils/datetime-utils";
import listItem_UpdateCalculatedValues from "./helpers/update-calculated-values";
import ModelProto from "../model-proto";
import ItemsCollection from "./items-collection";
import Project from "../project/project";
import Task from "../task/task";
import Event from "../event/event";
import {SystemStatus} from "../../gd/const/system-status";
import {ModelInterface} from "../../data-structures/collection";
import {EntityType} from "../../gd/const/item";
import {Priority} from "../../gd/types/types";
import Status from "../status/status";

export enum ItemDisplay {
    HIDDEN          = 0,
    VISIBLE         = 1,
    GHOST_VISIBLE   = 2, // visible ghost - i.e. search show parents
    GHOST_HIDDEN    = 3  // invisible ghost - ???
}

export const ItemDisplayDict = {
    [ItemDisplay.VISIBLE]       : 'Visible',
    [ItemDisplay.HIDDEN]        : 'Hidden',
    [ItemDisplay.GHOST_VISIBLE] : 'Ghost Visible',
    [ItemDisplay.GHOST_HIDDEN]  : 'Ghost Hidden'
}

type ListItemCalculatedValues = {
    own         : number
    children    : number
    total       : number
}

// this full tree values ! ... i.e. children of children etc.
export type NumberOfChildren = {
    tasks               : number,
    tasksOpen           : number,   // for organization projects list only, otherwise no tasksOpen parameter present
    tasksTotal          : number,   // for organization projects list only, otherwise no tasksTotal parameter present
    projects            : number,
    projectsOpen        : number,
    completedSubItems   : number,   // this is NOT grand-grand... just children


    projectTasksOpen    : number,   // Ok this one is used in projects list & summarty  tasksOpen & tasksTotal come from server calculated
    projectTasksTotal   : number,   // Ok this one is used in projects list & summarty  tasksOpen & tasksTotal come from server calculated
}

// const debug = "ItemModel"
const debug = false


export default class ItemModel extends ModelProto implements ModelInterface {

    public id!                      : RID

    public isRoot                   : boolean = false   // true if root in our tree
    public treeParent?              : ItemModel
    public treeChildren             : ItemModel[]   = []

    public type                     : EntityType // old values are task | project
    public display                  : ItemDisplay = ItemDisplay.VISIBLE // 0 | 1 | 2         = 1 // 1 - normal, display 2-ghost 0-none // ne pomnu chto tut tipo visible hiddent i ghost parent ?

    public parentId?                : RID | null = null // is it RID ? this is deprecated but still in use

    public item!                    : Task | Project | Event
    public childrenItems            : RID[] = []
    public collection               : ItemsCollection

    public isCollapsed              : boolean   = true
    public isSelected               : boolean   = false // bulk action

    public costInternal!            : ListItemCalculatedValues
    public costExternal!            : ListItemCalculatedValues
    public estimatedCostInternal!   : ListItemCalculatedValues
    public estimatedCostExternal!   : ListItemCalculatedValues

    public calculatedAttachments!   : ListItemCalculatedValues
    public calculatedStoryPoints!   : ListItemCalculatedValues
    public calculatedExpenses       : ListItemCalculatedValues = { own: 0, children: 0, total : 0}

    public reported!                : ListItemCalculatedValues // reportedTime
    public estimated!               : ListItemCalculatedValues // estimate

    public numChildren!             : NumberOfChildren // recursive ? yess full tree...

    public isEmptyProject           : boolean   = false

    public displayNumber            : number    = 0                 // This is table Grid row display number

    public viewSortPosition?        : number                        // currently is used for Task List only for local manual sorting

    // public _calculatedValues        : any // temp
    // public _values                  : any // ampersand model

    // link to rendered component - make sure we alwasy have only 1 (!!!!!!)
    renderComponent?                : any

    lastUpdateTime                  : number = 0 // used to check component shoud update


    constructor(data:any|Task|Project, collection:ItemsCollection, entityType?:EntityType) {

        super(data)

        this.collection         = collection
        this.type               = data.type

        let parent : RID | undefined = undefined

        // if(data.item && data.item.cid) obj.item.off(); // no idea chto eto ...

        if (data.entityType) {

            // init from resources model...

            switch (data.entityType) {

                case EntityType.TASK:
                    const task = data as Task

                    this.item   = task
                    this.type   = EntityType.TASK
                    // this.id     = 't-'+this.item.id;
                    this.id     = task.rid

                    if (this.item.parentTaskId) parent="t-"+this.item.parentTaskId;
                    else if (this.item.parentId) parent="p-"+this.item.parentId;
                    break

                case EntityType.PROJECT:
                    const project = data as Project
                    this.item   = project
                    this.type   = EntityType.PROJECT
                    // this.id     = 'p-'+this.item.id
                    this.id     = project.rid

                    if (this.item.parentId) parent="p-"+this.item.parentId; // parent project ID
                    break

                default:
                    console.warn("#943874 wtf ?")
            }


        } else {

            // standard init

            switch (this.type) {
                case EntityType.PROJECT:
                    this.item   = new Project(data.item);
                    this.id     = 'p-'+this.item.id

                    if (this.item.parentId) parent="p-"+this.item.parentId; // parent project ID
                    break;

                case EntityType.TASK:
                    this.item   = new Task(data.item);
                    this.id     = 't-'+this.item.id;

                    if (this.item.parentTaskId) parent="t-"+this.item.parentTaskId;
                    else if (this.item.parentId) parent="p-"+this.item.parentId;

                    break;
            }

        }

        this.parentId = parent;

        this._updateLastUpdateTime();   // a zachem ? - for example for TableRowTask shouldComponentUpdate check

    }

    get task():Task {
        return this.item as Task
    }

    get project():Project {
        return this.item as Project
    }

    get event():Event {
        return this.item as Event
    }

    get companyId() {
        return gd.companyId
    }

    initialize() {
        console.warn("DEPRICATED")
        // this.on('change', this.onDataChanged);
    }

    public _updateLastUpdateTime() {
        this.lastUpdateTime = Date.now()
    }

    /*** RENDER COMPONENT ***/

    // link dataItem with current render component (!)
    setRenderComponent(component:any) {
        this.renderComponent = component
    }

    // should be called when we delete or hide (collapse) component in component will unmount
    unsetRenderComponent() {
        this.renderComponent = undefined
    }

    /*** Collapse ***/

    collapse(silent=false) {
        if (this.isCollapsed) return false;
        this.isCollapsed = true;
        if (this.renderComponent && !silent) this.renderComponent.reRender();
    }

    expand(silent=false) {
        if (!this.isCollapsed) return false;
        this.isCollapsed = false;
        if (this.renderComponent && !silent) this.renderComponent.reRender();
    }

    toggleCollapsed(silent=false) {
        // if (this.isCollapsed)
        // ToDo
    }


    /*onDataChanged(model:any) {
        const changed = model.changedAttributes();
        if ('lastUpdateTime' in changed) return;
        if ('parentId' in changed && Object.keys(changed).length === 1) return; // only parent changed

        //console.log("TaskListModel onDataChanged", this.getName(), model, model.changedAttributes());
        this._updateLastUpdateTime();
    }

    onItemDataChanged(model:any) {
        const changed = model.changedAttributes();
        if ('sortPosition' in changed && Object.keys(changed).length === 1) return;

        //console.log("TaskListModel onItemDataChanged", this.getName(), model, model.changedAttributes());
        this._updateLastUpdateTime();
    }*/

    isOpen() {
        return gd.const.systemStatus.isOpen(this.item.systemStatus)
    }

    get isClosed():boolean {
        return this.item.isClosed
    }
    // isClosed() {
    //     return gd.const.systemStatus.isClosed(this.item.systemStatus)
    // }

    isParent(itemId:RID):boolean {

        // strange function don't like it get it ...

        if (this.id === itemId) {
            return false
        }


        let res : boolean = false;

        for (let i=0; i < this.childrenItems.length; i++) {
            const child = this.collection.get(this.childrenItems[i])
            if (child) {
                res = child.isParent(itemId);
            }
            // res = this.collection.get(this.childrenItems[i]).isParent(id);
            if (res) break;
        }

        return res;
    }

    get isProject() {
        return this.type === EntityType.PROJECT;
    }

    get isTask() {
        return this.type === EntityType.TASK
    }

    get isEvent() {
        return this.type === EntityType.EVENT
    }

    get isSubTask() {
        return this.type === EntityType.TASK && this.task.isSubtask
    }

    get isHidden() {
        return this.display === ItemDisplay.HIDDEN
    }

    get isVisible() {
        return this.display === ItemDisplay.VISIBLE
    }

    get isNotHidden() {
        return ![ItemDisplay.HIDDEN, ItemDisplay.GHOST_HIDDEN].includes(this.display)
    }

    applyDelta(data:any) {
        const isChanged = this.item.applyDelta(data);

        // item is moved
        if (this.isTask) {
            if (data.projectId)                         this.parentId = 'p-{0}'.f(data.projectId)
            if (data.hasOwnProperty('parentTaskId')) this.parentId = data.parentTaskId ? 't-{0}'.f(data.parentTaskId) : 'p-{0}'.f(this.task.projectId)
        }

        if (this.isProject) {
            if (data.hasOwnProperty('parentId'))    this.parentId = data.parentId ? 'p-{0}'.f(data.parentId) : null
        }

        this._updateLastUpdateTime()
        this.updateCalculatedValuesNew()

        if (this.parentId) {
            let currentParent = this.collection.get(this.parentId)
            if (currentParent) currentParent.updateCalculatedValuesNew()
        }

        return isChanged
    }

    update (data:any) {

        switch (this.type){
            case EntityType.PROJECT:
                if (data.id) {
                    this.item.id = data.id;
                    this.id = 'p-'+data.id;
                }

                if (data.projectId) {
                    this.project.parentId = data.projectId;
                    // @ts-ignore
                    this.project.projectId = data.projectId;   // ???? huh
                }
                if (data.priority) this.project.priority = data.priority;
                if (data.sortPosition) this.item.sortPosition = data.sortPosition;

                break;

            case EntityType.TASK:
                if (data.id) {
                    this.item.id = data.id;
                    this.id = 't-'+data.id;
                }

                if (data.shortId) this.task.shortId = data.shortId;
                if (data.parentTaskId) this.task.parentTaskId = data.parentTaskId;
                if (data.projectId) {
                    // if (!data.isTagView) this.task.parentId = data.projectId
                    if (!data.isTagView) {
                        this.task.projectId = data.projectId
                    } else {
                        this.task.projectId = data.projectId;
                    }
                }

                if (data.priority) this.task.priority = data.priority;
                // this.item.progress = data.progress;
                if (data.customFieldsData) this.item.customFieldsData = data.customFieldsData;

                if (data.actionRequiredUserId) this.task.actionRequiredUserId = data.actionRequiredUserId;
                if (data.systemStatus) this.task.systemStatus = data.systemStatus;
                if (data.statusId) this.task.statusId = data.statusId;
                if (data.taskStatusId) this.task.statusId = data.taskStatusId;

                if (data.sortPosition) this.item.sortPosition = data.sortPosition;
                break;
        }
    }

    changeParent(parentItem?:ItemModel) {

        debug && console.log(debug, "changeParent()")

        if (this.parentId) {
            let currentParent = this.treeParent
            if (currentParent) {
                // currentParent.removeChild(this.id); // old
                currentParent.removeChildItem(this); // new
            }
        }

        if (parentItem){
            // old
            // let newParent = this.collection.get(parentItem.id);
            // if (newParent) newParent.addChild(this.id);

            parentItem.addChildItem(this); // new

            this.parentId   = parentItem.id; // we still need it - nado poiskat' gde i chto
            this.treeParent = parentItem

            switch (parentItem.type) {
                case EntityType.TASK:
                    //this.item.parentId = null;
                    this.task.parentTaskId  = parentItem.task.id;
                    this.task.systemType    = gd.const.taskSystemType.SUBTASK;
                    console.log("a chto esli pomenyalsya i project #4394784")
                    this.isCollapsed        = true; //expand is not allowed for subtasks;
                    break;

                case EntityType.PROJECT:
                    // this.project.parentId = parentItem.item.id;
                    // // @ts-ignore
                    // this.project.projectId = parentItem.item.id;

                    if (this.isTask) {

                        this.task.projectId = parentItem.project.id

                        this.task.parentTaskId = null;
                        this.project.systemType = gd.const.taskSystemType.TASK;
                    }

                    if (this.isProject) {
                        this.project.parentId = parentItem.project.id
                    }
                    break;
            }
        } else {
            //move to root
            this.parentId = null;

            if (this.isProject) {
                // // @ts-ignore
                this.project.parentId = null;
            }


            if (this.isTask){
                this.task.parentTaskId  = null;
                this.task.systemType    = gd.const.taskSystemType.TASK;
            }
        }
    }

    // Deprecated
    removeChild(childId:ID) {
        _.remove(this.childrenItems, (ci) => ci === childId);
        this.updateCalculatedValuesNew();
    }

    // Deprecated
    addChild(childId:RID) {
        this.childrenItems.push(childId);
        this.updateCalculatedValuesNew();
    }

    addChildItem(item:ItemModel) {
        this.childrenItems.push(item.id);
        this.treeChildren.push(item)
        this.updateCalculatedValuesNew();
    }

    removeChildItem(item:ItemModel) {
        _.remove(this.childrenItems, (id:RID) => id === item.id);
        _.remove(this.treeChildren, (iterateItem:ItemModel) => iterateItem.id === item.id);

        this.updateCalculatedValuesNew();
    }

    setStatus(statusId:ID, actionRequiredUserId?:ID) {
        let status : Status = gd.session.statuses.get(statusId)

        switch (this.type){
            case EntityType.PROJECT:

                this.project.systemStatus   = status.systemStatus;
                this.project.statusId       = statusId;


                break;

            case EntityType.TASK:

                this.task.systemStatus      = status.systemStatus;
                this.task.statusId          = statusId;

                if (gd.const.systemStatus.isClosed(this.item.systemStatus))
                    this.task.actionRequiredUserId = null;
                else if (actionRequiredUserId)
                    this.task.actionRequiredUserId = actionRequiredUserId;
                break;

            case EntityType.EVENT:
            default:
                break
        }
    }

    setSystemStatus(status:SystemStatus){
        switch (this.type){
            case EntityType.PROJECT:
                this.project.systemStatus = status;
                break;
        }
    }

    setPriority(priorityValue:Priority, actionRequiredUserId?:ID) {

        if (this.isEvent) return

        switch (this.type) {
            case EntityType.TASK:
                this.task.priority = priorityValue;
                if (actionRequiredUserId) this.task.actionRequiredUserId = actionRequiredUserId;
                break
            case EntityType.PROJECT:
                this.project.priority = priorityValue;
                break
            case EntityType.EVENT:
            default:
                break
        }




    }

    setAR(actionRequiredUserId:ID){
        switch (this.type){
            case EntityType.PROJECT:
                break;

            case EntityType.TASK:
                this.task.setAR(actionRequiredUserId);
                break;
        }
    }

    setAssignedToUser(assignedToUserId:ID) {
        switch (this.type){
            case EntityType.PROJECT:
                break;

            case EntityType.TASK:
                this.task.setAssignedToUser(assignedToUserId);
                break;
        }
    }

    setOwnerUser(ownerUserId:ID) {
        switch (this.type){
            case EntityType.PROJECT:
                // this.project.setOwnerUser(ownerUserId);
                this.project.ownerUserId    = ownerUserId
                break;

            case EntityType.TASK:
                break;
        }
    }

    setProjectManagerUser(managerUserId:ID) {

        console.error("DEPRITCATED #DKDJEDIOE33")

        switch (this.type){
            case EntityType.PROJECT:
                this.project.setProjectManagerUser(managerUserId);
                break;

            case EntityType.TASK:
                break;
        }
    }

    setSortPosition(sortPosition:number) {
        // this.item.setSortPosition(sortPosition); - old

        switch (this.type){
            case EntityType.PROJECT:
                this.project.sortPosition = sortPosition
                break;

            case EntityType.TASK:
                this.task.sortPosition  = sortPosition
                break;
        }


    }

    setStoryPoints(value:number) {
        switch (this.type){
            case EntityType.PROJECT: /*do nothing*/ break;

            case EntityType.TASK:
                // this.task.setStoryPoints(value);
                this.task.storyPoints   = value
                break;
        }
    }

    setIsSelected(val:boolean) {
        this.isSelected = val;
        this._updateLastUpdateTime()
    }

    getIsSelected() {
        return this.isSelected;
    }

    isAnyParentSelected() {
        let res = false;

        const _collection = this.collection;
        function collectParent(parentId?:RID|null) {
            if (parentId){
                const parent = _collection.get(parentId);
                if (parent){
                    if (parent.getIsSelected()) res = true;
                    collectParent(parent.parentId);
                }
            }
        }

        collectParent(this.parentId);

        return res;
    }

    updateCalculatedValuesNew() {
        listItem_UpdateCalculatedValues(this)
    }

    countChildrenTasks() {
        if (!this.numChildren) {
            console.warn("#kd787934 - something wrong with num children!")
            return 0
        }

        return this.numChildren.tasks
    }

    get childrenTotal() {
        // calculates closed projects too

        if (!this.numChildren) {
            console.warn("#kdd8934 - something wrong with num children!")
            return 0
        }

        return this.numChildren.tasks + this.numChildren.projects
    }

    countProgressSubItems() {
        let res = 0;

        this.childrenItems.map((childrenId) => {
            let child = this.collection.get(childrenId);
            if (child && gd.const.systemStatus.isClosed(child.item.systemStatus)) res++;
        });

        return res;
    }

    // Old one... feel like we can delete it...
    // countProgressAuto(includeThis = false) {
    //     let res = 0;
    //
    //     if (includeThis && gd.const.systemStatus.isClosed(this.item.systemStatus)) res = 100;   // if this item is closed, then progress is 100%
    //     else if (includeThis && !!this.item.progress) res = this.item.progress;                 // if progress is set then use this value and no children calculation required
    //     else if (this.childrenItems.length > 0) {                                               // otherwise count child items progress
    //         this.childrenItems.map((childrenId) => {
    //             let child = this.collection.get(childrenId);
    //             if (child) {
    //                 res += child.countProgressAuto(true);
    //             }
    //         });
    //         res = gd.utils.roundToDecimals(res/this.childrenItems.length, 2);
    //     }
    //
    //     return res;
    // }

    getAllChildrenIds() {
        const res : any[] = [];
        this.childrenItems.map((childrenId) => {
            const child = this.collection.get(childrenId);
            if (child) {
                res.push(child.id);

                child.getAllChildrenIds().map((cId) => { res.push(cId); });
            }
        });
        return res;
    }

    getAllChildren(openOnly:boolean) {
        let res : any[] = [];
        if (this.childrenItems.length > 0) {
            this.childrenItems.map((childrenId) => {
                const child = this.collection.get(childrenId);
                if (child && (!openOnly || child.isOpen())) {
                    res.push(child);
                    res = res.concat(child.getAllChildren(openOnly));
                }
            });
        }
        return res;
    }

    getAllInvolvedUsersIds():ID[] {
        let res : ID[] = [];

        if (this.isTask) {
            _.map(this.task.users,(user:any)=>{
                res.push(user.userId)
                console.log("456 or user.id ??")
            })
            // res = this.task.users?.map(u=>u.userId);
        }

        this.childrenItems.map((childrenId) => {
            const child = this.collection.get(childrenId);
            if (child) {
                res = res.concat(child.getAllInvolvedUsersIds());
            }
        });

        return res;
    }

    getProjectChildrenLevel(baseLevel = 1) {
        let res = baseLevel;
        if (this.childrenItems.length > 0) {
            let additionalLevel = 0;
            this.childrenItems.map((childrenId) => {
                const child = this.collection.get(childrenId);
                if (child && child.isProject){
                    additionalLevel = child.getProjectChildrenLevel(baseLevel + 1);
                    if (res < additionalLevel) res = additionalLevel;
                }
            });
        }
        return res;
    }

    getProjectChildren() {
        let res : any = [];
        if (this.childrenItems.length > 0) {
            this.childrenItems.map((childrenId) => {
                const child = this.collection.get(childrenId);
                if (child && child.isProject){
                    res.push(child);
                    res = res.concat(child.getProjectChildren());
                }
            });
        }
        return res;
    }

    getAllParents():any[] {
        const res   : any[] = [];

        const _collection = this.collection;

        function collectParent(parentId?:RID|null) {
            if (!parentId) return

            const parent = _collection.get(parentId);
            if (parent){
                res.push(parent);
                collectParent(parent.parentId);
            }
        }

        collectParent(this.parentId);

        return res;
    }

    getName() {
        switch (this.type){
            case EntityType.TASK: return this.task.title;
            case EntityType.PROJECT: return this.item.name;
        }
    }

    getDurationStart():Moment {

        // Gantt has it's own (!!!)
        // this is strage function ...

        let res;
        if (this.isProject && [gd.const.project.type.BACKLOG].includes(this.project.systemType)) {
            const displayStartDate = this.item.displayStartDate
            res = displayStartDate ? displayStartDate : momentDate(); //(Moment().format("YYYY-MM-DD"));
        } else {
            res = this.item.startDate ? this.item.startDate : momentDate(); //Moment(Moment().format("YYYY-MM-DD"));
        }
        return res;
    }


    getTags() {
        console.warn("#409485 tags - use item.task.tags")
        // @ts-ignore
        return this.item.tags
    }

    clone() {

        // used in board for sure (!) maybe somewhere else ...

        const json = this.toJSON()
        // somehow customFieldsData remains referenced so we need to clone it manually
        if (json.item.customFieldsData) json.item.customFieldsData = _.cloneDeep(json.item.customFieldsData)

        return new ItemModel(json, this.collection)
    }

    toJSON() {

        const result : any = {
            id                      : this.id,
            type                    : this.type,

            display                 : this.display,

            parentId                : this.parentId,

            item                    : this.item.toJSON(),
            childrenItems            : this.childrenItems,
            collection               : this.collection,

            isCollapsed              : this.isCollapsed,
            isSelected               : this.isSelected,

            costInternal            : this.costInternal,
            costExternal            : this.costExternal,
            estimatedCostInternal   : this.estimatedCostInternal,
            estimatedCostExternal   : this.estimatedCostExternal,

            reported                : this.reported,
            estimated               : this.estimated,

            numChildren             : _.cloneDeep(this.numChildren),

            isEmptyProject           : this.isEmptyProject,


        //     renderComponent                : this.renderComponent

                lastUpdateTime                  : this.lastUpdateTime



        }


        return result
    }

    debugChildren() {

        let res = ""
        _.map(this.treeChildren, (child)=>{
            res += child.getName() + ", "
        })

        console.log("children=", res)
    }

    get debugName():string {
        switch (this.type){
            case EntityType.TASK: return this.task.title;
            case EntityType.PROJECT: return this.item.name;
        }

        throw Error("#9487476 unknown type")
    }

}

